import './App.css';
import './style/index.css'
import { IndexComponent } from './components/IndexComponent';

function App() {
  return ( <IndexComponent /> );
}

export default App;
